<div class="flex flex-col gap-1 px-2">
  <!-- Header Section  -->
  <div class="flex items-center justify-between py-2">
    <h2 class="textTabsColor text-2xl font-bold" i18n="@@pharmacySegmentsTitle">Pharmacy Segments</h2>
    <button
      (click)="onAddSegment()"
      class="bgPrimaryColor hover:bgHoverPrimaryColor flex items-center gap-2 rounded-md px-4 py-2 text-sm font-medium text-white transition-colors hover:cursor-pointer">
      <app-add-icon />
      <span i18n="@@addPharmacySegment">Create New Segment</span>
    </button>
  </div>

  <!-- Filters -->
  <app-pharmacy-segment-filter
    [(titleFilter)]="titleFilter"
    [(paymentTermFilter)]="paymentTermFilter"
    [(createdOnFrom)]="createdOnFrom"
    [(createdOnTo)]="createdOnTo"
    [(modifiedOnFrom)]="modifiedOnFrom"
    [(modifiedOnTo)]="modifiedOnTo"
    [(orderBy)]="orderBy"
    [orderDir]="orderDir()"
    (toggleOrder)="toggleSortOrder()"
    (apply)="applyFilters()"
    (reset)="resetFilters()" />

  <!-- Table -->
  <app-pharmacy-segment-table
    [segments]="segments()"
    [currentPage]="currentPage()"
    [itemsPerPage]="itemsPerPage()"
    [isFiltersApplied]="isFiltersApplied()"
    (edit)="onEditSegment($event)" />

  <!-- Pagination Component -->
  @if (segments().length > 0) {
    <app-pagination
      [itemsPerPage]="itemsPerPage()"
      [currentPage]="currentPage()"
      [getPageNumbers]="getPageNumbers()"
      [totalPages]="totalPages()"
      [startItem]="startItem()"
      [endItem]="endItem()"
      [totalItems]="totalItems()"
      (previousPage)="previousPage()"
      (nextPage)="nextPage()"
      (goToPage)="goToPage($event)"
      (changePageNumber)="onPageSizeChange($event)"></app-pagination>
  }
</div>